import { render, staticRenderFns } from "./imprDetailAppr.vue?vue&type=template&id=e54e79f0"
import script from "./imprDetailAppr.vue?vue&type=script&lang=js"
export * from "./imprDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e54e79f0')) {
      api.createRecord('e54e79f0', component.options)
    } else {
      api.reload('e54e79f0', component.options)
    }
    module.hot.accept("./imprDetailAppr.vue?vue&type=template&id=e54e79f0", function () {
      api.rerender('e54e79f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/ibm/imprDetailAppr.vue"
export default component.exports